// <generated-client-wrappers:imports>
import type * as WrapperApi from '../generated/model/models';
import type * as WrapperHttp from '@angular/common/http';
import type * as WrapperRx from 'rxjs';
// </generated-client-wrappers:imports>
import { Injectable } from '@angular/core';
import { JobsService } from '../generated/api/jobs.service';

@Injectable({ providedIn: 'root' })
export class JobsClientService {
  constructor(private readonly client: JobsService) {}
  // <generated-client-wrappers:methods>
  freeze(
    key: string,
    request: WrapperApi.FreezeJobRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.JobDefinitionResponse> {
    if (!this.client) throw new Error('JobsService is not available');
    return this.client.jobsFreeze(
      key,
      request,
      'body',
      reportProgress,
      options,
    );
  }

  getJobs(
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Array<WrapperApi.JobDefinitionResponse>> {
    if (!this.client) throw new Error('JobsService is not available');
    return this.client.jobsGetJobs('body', reportProgress, options);
  }

  run(
    key: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.JobRunResponse> {
    if (!this.client) throw new Error('JobsService is not available');
    return this.client.jobsRun(key, 'body', reportProgress, options);
  }

  unfreeze(
    key: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.JobDefinitionResponse> {
    if (!this.client) throw new Error('JobsService is not available');
    return this.client.jobsUnfreeze(key, 'body', reportProgress, options);
  }
  // </generated-client-wrappers:methods>
}
